import React from "react";
import { Box, useTheme } from "@mui/material";

interface OcSidebarBadgeProps {
  value: number;
  id?: string;
  urgent?: boolean;
}

export const OcSidebarBadge: React.FC<OcSidebarBadgeProps> = ({
  value,
  id,
  urgent,
}) => {
  const theme = useTheme();
  if (!value) return null;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.gray40.main,
        borderRadius: "2px",
        marginLeft: "4px",
        paddingTop: "2px",
        width: value >= 100 ? "unset" : "16px",
        height: "16px",
        display: value < 100 ? "flex" : "unset",
      }}
    >
      <Box
        id={id}
        sx={{
          fontSize: "10px",
          fontFamily: "Mulish",
          lineHeight: "16px",
          color: urgent
            ? theme.palette.primary.main
            : theme.palette.darkBase.main,
          fontWeight: "bold",
          textAlign: "center",
          width: "20px",
        }}
      >
        {value > 99 ? "99+" : value}
      </Box>
    </Box>
  );
};
